export interface CountryHolidaySyncResult {
  country: string;
  year: number;
  created: number;
  updated: number;
  preservedManual: number;
  skipped: number;
}

export class CountryHolidayModel {
  constructor(
    public id?: string,
    public country?: string,
    public holidayDate?: string,
    public name?: string | null,
    public source?: string,
    public createdAt?: string,
    public updatedAt?: string
  ) {}

  public fromJSON(json: any): CountryHolidayModel {
    if (json) {
      this.id = json.id;
      this.country = json.country;
      this.holidayDate = json.holidayDate;
      this.name = json.name ?? null;
      this.source = json.source;
      this.createdAt = json.createdAt;
      this.updatedAt = json.updatedAt;
    }
    return this;
  }

  public fromJSONList(json: any): CountryHolidayModel[] {
    if (json) {
      return json.map((element: any) => new CountryHolidayModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      country: this.country,
      holidayDate: this.holidayDate,
      name: this.name ?? null,
    };
  }

  public getId() {
    return this.id ?? '';
  }

  public getReference() {
    return this.country && this.holidayDate ? `${this.country} ${this.holidayDate}` : '';
  }
}
